import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
// eslint-disable-next-line import/no-cycle
import { CardExpiryChangeEvent } from "@shared/modules/payments/common/CardExpiryInput/CardExpiryInput.props";
import { useTranslation } from "@shared/utils/internationalization";
import { useCallback, useState } from "react";
// eslint-disable-next-line import/no-cycle
import AuthorizeElement from "../AuthorizeElement/AuthorizeElement.web";

export type AuthorizeCardExpiryElementProps = {
  /**
   * Fires when a value is well-formed and potentially complete.
   * It is not an indicator of whether a customer is done with their input --
   * it only indicates that the Element contains a potentially complete, well-formed value.
   */
  onValidField?: () => void;
  /**
   * Fires when a value is deemed invalid
   */
  onInvalidField?: () => void;
};

/**
 * A containing element for a an AuthorizeElement component configured as a cardExpiry element.
 */
function AuthorizeCardExpiryElement({
  onValidField,
  onInvalidField,
}: AuthorizeCardExpiryElementProps) {
  const { t } = useTranslation("checkout");
  const [error, setError] = useState("");

  const handleChange = useCallback(
    (evt: CardExpiryChangeEvent) => {
      // Event handling is unique per element
      if (evt.error) {
        setError(evt.error.message);
      } else if (!evt.error) {
        setError("");
      }

      if (evt.complete) {
        onValidField?.();
      } else {
        onInvalidField?.();
      }
    },
    [onValidField, onInvalidField]
  );

  return (
    <Box>
      <Box>
        <Text fontWeight={700} mb="2xs" fontSize="0.875rem">
          {t("Expiration")}
        </Text>
      </Box>
      <Box
        border="1px solid"
        borderColor={!error ? "border" : "red.600"}
        borderRadius="sm"
        padding="0px 12px"
        lineHeight="1.2em"
        bg="bg"
      >
        <AuthorizeElement element="cardExpiry" onChange={handleChange} />
      </Box>
      <Box>
        <Text
          color="red.600"
          noOfLines={3}
          data-testid="authorize-element-cardExpiry-error"
        >
          {error}
        </Text>
      </Box>
    </Box>
  );
}

export default AuthorizeCardExpiryElement;
